import React from 'react';
import { Trans } from '@lingui/macro';
import _ from 'lodash';

import { hideMiddleName } from '../../est/filters';

export type LeadNameProps = {
  name: string | null | undefined;
  hideMiddleName?: boolean;
};

export function LeadName({ name, hideMiddleName: hideMiddle }: LeadNameProps) {
  if (!name) {
    return <Trans id="unit.popup.noname">No name</Trans>;
  }

  if (hideMiddle) {
    name = hideMiddleName(name);
  }

  return _.upperFirst(name);
}
